/**
 * This file handle the logic for hero slider on frontpage
 */
import Swiper, { Navigation, Pagination, EffectFade, Autoplay } from 'swiper';

const homepageHero = document.getElementById('hero-slider-wrapper');
const slides = homepageHero.getElementsByClassName('swiper-slide');

/**
 * run Swiper slider
 *
 * @var heroSlider The array coming from localize script in functions.php
 */
// check is autoplay set in hero options
const sliderAutoplay = heroSlider.autoplay ? { delay: heroSlider.delay, disableOnInteraction: true } : false;
// check if we hide pagination or not
const sliderPagination = heroSlider.pagination ? false : {
  el: '.hero-slider__pagination',
  clickable: true,
};
const sliderNavigation = heroSlider.pagination ? false : {
  nextEl: '.hero-slider__right',
  prevEl: '.hero-slider__left',
};

if(slides.length > 1) {
  const heroSwiper = new Swiper ('.hero-slider__container', {
    // Optional parameters
    modules: [Navigation, Pagination, EffectFade, Autoplay],
    slidesPerView: 1,
    loop: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    autoplay: sliderAutoplay,
    navigation: sliderNavigation,
    pagination: sliderPagination
  });
}